import { baseUrl } from "@/requestConfig/baseUrl";
import * as signalR from "@microsoft/signalr";
import { initLogout } from "./logoutCallBack";
const { signalr } = baseUrl;
export const signalrInit = (token: string, userId: string) => {
  const baseUrl_sr = `${signalr}?userid=${userId}&pt=dgj`;

  let RelinkNumber = 1;
  let connection: any;
  function linkSignalr() {
    // 建立连接
    connection = new signalR.HubConnectionBuilder()
      .withUrl(baseUrl_sr, {
        accessTokenFactory: () => token,
      })
      .build();
  }
  linkSignalr();

  function goOnline() {
    // 登出处理
    initLogout(connection);
  }
  goOnline();

  function signalrInitAgain() {
    if (RelinkNumber >= 2) {
      return false;
    }
    RelinkNumber++;
    linkSignalr();
    goOnline();
    start();
    onClose();
  }

  // 开始连接
  connection
    .start()
    .then(function () {
      RelinkNumber = 1;
    })
    .catch(function () {
      signalrInitAgain();
    });

  // 重新链接方法
  async function start() {
    try {
      await connection.start();
    } catch (err) {
      if (RelinkNumber >= 2) {
        return false;
      }
      setTimeout(() => start(), 5000);
    }
  }

  // 掉线自动重连
  function onClose() {
    connection.onclose(async () => {
      console.log("-----------------------------------------------signalr掉线-----------------------------------------------");
      await signalrInitAgain();
    });
  }
  onClose();
};
